import { Grid } from '@mui/material';
import { useFunctionariesSwitchData } from './hook';
import { FunctionariesSwitchDataProps } from './props';

import FieldText from '../../../../../components/general/fields/fieldText';
import { Checkbox } from '../../../../../components/general/fields/checkbox';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const FunctionariesSwitchData = (
    props: FunctionariesSwitchDataProps
) => {
    const { formik, areaOptions, positionOptions, cityOptions } =
        useFunctionariesSwitchData(props);
    const { isAdmin } = props;

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    required={!formik.values.name}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Apellido"
                    name="surname"
                    size="small"
                    required={!formik.values.surname}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.surname}
                    errors={formik.errors.surname}
                    value={formik.values.surname}
                    onChange={formik.handleChange}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Correo electrónico"
                    name="email"
                    size="small"
                    required={!formik.values.email}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.email}
                    errors={formik.errors.email}
                    value={formik.values.email}
                    onChange={formik.handleChange}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Teléfono"
                    name="phone"
                    size="small"
                    required={!formik.values.phone}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.phone}
                    errors={formik.errors.phone}
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <FieldText
                    label="Extensión"
                    name="extension"
                    size="small"
                    required={!formik.values.extension}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.extension}
                    errors={formik.errors.extension}
                    value={formik.values.extension}
                    onChange={formik.handleChange}
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <AutocompleteField
                    data={formatParams(cityOptions)}
                    label="Ciudad"
                    name="city"
                    size="small"
                    
                    disabled={cityOptions.length === 0}
                    onBlur={formik.handleBlur}
                    touched={(formik.touched as any).city}
                    errors={(formik.errors as any).city}
                    value={(formik.values as any).city}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('city', value)
                    }
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    disabled={!isAdmin && !formik.values.active}
                    onChange={() =>
                        formik.setFieldValue('active', !formik.values.active)
                    }
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <AutocompleteField
                    data={formatParams(areaOptions)}
                    label="Área"
                    name="area"
                    size="small"
                    required={!formik.values.area}
                    disabled={areaOptions.length === 0}
                    onBlur={formik.handleBlur}
                    touched={(formik.touched as any).area}
                    errors={(formik.errors as any).area}
                    value={(formik.values as any).area}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('area', value)
                    }
                />
            </Grid>

            <Grid item xs={12} sm={6}>
                <AutocompleteField
                    data={formatParams(positionOptions)}
                    label="Cargo"
                    name="position"
                    size="small"
                    required={!formik.values.position}
                    disabled={positionOptions.length === 0}
                    onBlur={formik.handleBlur}
                    touched={(formik.touched as any).position}
                    errors={(formik.errors as any).position}
                    value={(formik.values as any).position}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('position', value)
                    }
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Descripción"
                    name="description"
                    size="small"
                    rows={3}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.description}
                    errors={formik.errors.description}
                    value={formik.values.description}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
